import styled from 'styled-components';
import Input from 'components/common/input';

export const InputStyled = styled(Input)``;
